import './style.scss';
import { defineComponent, ref, onMounted } from 'vue';

let $banner = null;

export const $info = (opts) => {
  $banner?.$info(opts);
};

$info.clear = () => {
  $banner && ($banner.banners.value = []);
};

export default defineComponent({
  props: {
    max: {
      type: Number,
      default: 1,
    },
  },
  setup(props) {
    const banners = ref([]);
    const alertBanner = (opts) => {
      const { message, className, ...restProps } = opts;
      return (
        <zm-banner class={`banner-container__alert-item ${className || ''}`} {...restProps}>
          <span innerHTML={message}></span>
        </zm-banner>
      );
    };

    const $info = (opts) => {
      const bannerItem = alertBanner({
        type: 'info',
        ...opts,
      });
      const newList = [bannerItem, ...banners.value];
      banners.value = newList.slice(0, props.max);
    };

    onMounted(() => {
      $banner = {
        banners,
        $info,
      };
    });

    return () => <div class="banner-container">{banners.value}</div>;
  },
});
